<template>
  <v-container v-if="personal" fluid>
    <v-row>
      <v-col cols="4">
        <v-btn text class="mx-2" v-on:click="$router.go(-1)"
          ><v-icon>mdi-arrow-left</v-icon> Volver a catálogo de personal</v-btn
        >
      </v-col>
      <v-col cols="8" align="right">
        <v-spacer></v-spacer>
        <v-btn
          v-on:click="download(personal.foto)"
          rounded
          color="secondary"
          class="mx-2"
          v-if="personal.foto.length > 0"
          >Descargar fotografía</v-btn
        >
      </v-col>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <personal-card-component :personal="personal"></personal-card-component>
          </v-col>
          <v-col cols="12">
            <menu-list-component :estatus="personal.fk_idEstatus" :loading="loadingPersonalData"></menu-list-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9" v-if="loadingPersonalData == false">
        <datos-generales-component
          v-if="selectedMenu == 1"
          :personal="personal"
          :estudios="estudiosPersonal"
        ></datos-generales-component>
        <referencias-component
          v-if="selectedMenu == 2"
          :personal="personal"
          :referencias="referencias"
          :familiares="familiares"
        ></referencias-component>
        <documentos-component
          v-if="selectedMenu == 3"
          :documentos="documentos"
          :id="personal.idPersonal"
        ></documentos-component>
        <desarrollo-elemento-component
          v-if="selectedMenu == 4"
          :personal="personal"
          :evaluaciones="evaluacionesMedicas"
          :dictamenes="dictamenes"
          :biometricos="biometricosPersonal"
          :cursos="cursos"
          :evaluaciones-productividad="evaluacionesPersonalProductividad"
          :armas="armasPersonal"
          :equipamiento="equipamientoPersonal"
        ></desarrollo-elemento-component>
        <puesto-dependencia-component v-if="selectedMenu == 5" :personal="personal"></puesto-dependencia-component>
        <area-adscripcion-component v-if="selectedMenu == 6" :personal="personal"></area-adscripcion-component>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row>
      <v-col cols="3">
        <v-row>
          <v-col cols="12">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader type="image"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9">
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.selectable {
  cursor: pointer;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import PersonalCardComponent from '../../components/expediente/PersonalCardComponent.vue'
import MenuListComponent from '../../components/expediente/MenuListComponent.vue'
import DatosGeneralesComponent from '../../components/expediente/DatosGeneralesComponent.vue'
import DocumentosComponent from '../../components/expediente/DocumentosComponent.vue'
import DesarrolloElementoComponent from '../../components/expediente/DesarrolloElemento.vue'
import AreaAdscripcionComponent from '../../components/expediente/AreaAdscripcionComponent.vue'
import ReferenciasComponent from '../../components/expediente/ReferenciasComponent.vue'
import PuestoDependenciaComponent from '../../components/expediente/PuestoDependenciaComponent'

export default {
  components: {
    PersonalCardComponent,
    MenuListComponent,
    DatosGeneralesComponent,
    DocumentosComponent,
    DesarrolloElementoComponent,
    AreaAdscripcionComponent,
    ReferenciasComponent,
    PuestoDependenciaComponent,
  },

  async mounted() {
    await this.SET_SELECTED_MENU(1)
    this.loadingPersonalData = true
    await this.fetchPersonalById(this.id)
    await this.fetchReferenciasByPersonal(this.id)
    await this.fetchFamiliaresByPersonal(this.id)
    await this.fetchEstudiosByPersonal(this.id)
    await this.fetchEvaluacionMedicaByPersonal(this.id)
    await this.fetchDictamenPersonal(this.id)
    await this.fetchBiometricosPersonal(this.id)
    await this.fetchCursosAsignados()
    await this.fetchDocumentoByPersonal(this.id)
    this.loadingPersonalData = false
  },

  props: {
    id: {
      type: Number,
    },
  },

  data() {
    return {
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      loadingPersonalData: false,
      estadoNace: null,
      municipioNace: null,
      estadoRadica: null,
      municipioRadica: null,
      estadoDireccion: null,
      municipioDireccion: null,
      saveChanges: false,

      menuNacimiento: false,
      date: null,
    }
  },

  watch: {
    menuNacimiento(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),

    ...mapGetters('estudio', {
      estudios: 'getEstudios',
    }),

    ...mapGetters('documento', {
      documentos: 'getDocumentos',
    }),

    ...mapGetters('tipoNacionalidad', {
      tipoNacionalidad: 'getTipoNacionalidad',
    }),

    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),

    ...mapGetters('estado', {
      estados: 'getEstados',
    }),

    ...mapGetters('sexo', {
      sexo: 'getSexo',
    }),

    ...mapGetters('armaPersonal', {
      armasPersonal: 'getArmasPersonal',
    }),

    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    ...mapGetters('asignacionEquipo', {
      equipamientoPersonal: 'getAsignacionesEquipo',
    }),

    ...mapGetters('cursoAsignado', {
      cursos: 'getCursosAsignados',
    }),

    ...mapGetters('productividad', {
      evaluacionesProductividad: 'getProductividad',
    }),

    ...mapGetters('respetoPrincipios', {
      evaluacionesRespetoPrincipios: 'getRespetoPrincipios',
    }),

    ...mapGetters('expediente', {
      selectedMenu: 'getSelectedMenu',
    }),

    ...mapGetters('evaluacionMedica', {
      evaluacionesMedicas: 'getEvaluacionMedica',
    }),

    ...mapGetters('dictamenPersonal', {
      dictamenes: 'getDictamenPersonal',
    }),

    ...mapGetters('referencias', {
      referencias: 'getReferencias',
    }),

    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),

    menu: function () {
      return []
    },

    estudiosPersonal: function () {
      if (this.estudios) {
        return this.estudios.filter((estudio) => {
          return estudio.fk_idPersonal == this.id
        })
      } else return []
    },

    cursosPersonal: function () {
      if (this.cursos) {
        return this.cursos.filter((cursoAsignado) => {
          return cursoAsignado.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalProductividad: function () {
      if (this.evaluacionesProductividad) {
        return this.evaluacionesProductividad.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },

    evaluacionesPersonalRespetoPrincipios: function () {
      if (this.evaluacionesRespetoPrincipios) {
        return this.evaluacionesRespetoPrincipios.filter((evaluacion) => {
          return evaluacion.fk_idPersonal == this.id
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('documento', ['fetchDocumentoByPersonal']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('estatusDocumento', ['updateEstatusDocumento']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapActions('referencias', ['fetchReferenciasByPersonal']),
    ...mapActions('familiares', ['fetchFamiliaresByPersonal']),
    ...mapMutations('expediente', ['SET_SELECTED_MENU']),

    selectMenu: function (menu) {
      this.selectedMenu = menu
    },

    triggerUpdateEstatusDocumento: async function (documento) {
      await this.updateEstatusDocumento({
        idPersonal: documento.fk_idPersonal,
        idDocumentoPersonal: documento.iddocumentosPersonal,
      })
      await this.fetchDocumentoByPersonal(this.id)
    },

    triggerUpdatePersonal: async function () {
      var x = this.personal

      if (this.municipioNace) {
        this.personal.fk_idMunicipioNacimiento = this.municipioNace
      }
      if (this.municipioRadica) {
        this.personal.fk_idMunicipioRadica = this.municipioRadica
      }
      if (this.municipioDireccion) {
        this.personal.Contacto.Direccion.fk_idMunicipio = this.municipioDireccion
      }
      await this.updatePersonal(x)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.personal.fechaNacimiento = moment(date).format(this.API_DATE_FORMAT)
    },
  },
}
</script>
